import { selectAdminApiUrl } from 'util/selector/apiSelector';

import { createSelector } from '@reduxjs/toolkit';
import { AdminState } from 'reduxStore/appStore';
import { selectCommitEmployeeDatabaseJob } from 'reduxStore/job/selectors';
import { selectCurrentProjectId } from 'reduxStore/project/projectSelector';
import { JobStatus } from 'model/JobStatus';

import { EmployeeState } from './initialState';

export const selectEmployeeDomain = (state: AdminState) => state.employee as EmployeeState.Domain;

export const selectEmployeeList = createSelector(selectEmployeeDomain, (domain) => domain.list);

// TODO Move outside, it is not selector related to employee
export const selectEmployeeTemplateUrl = createSelector(
  selectCurrentProjectId,
  selectAdminApiUrl,
  (projectId, adminApiUrl) => `${adminApiUrl}/api/v1/project/${projectId}/employees-template`,
);

export const selectHasEmployees = createSelector(selectCommitEmployeeDatabaseJob, (job) =>
  job ? job.job.status === JobStatus.Success : false,
);

export const selectHasEmployeeList = createSelector(selectEmployeeList, (list) => list?.length > 0);

export const selectEmployeeListPagination = createSelector(
  selectEmployeeDomain,
  (domain) => domain?.listPagination,
);

export const selectTotalEmployeesCount = createSelector(
  selectEmployeeListPagination,
  (pagination) => pagination?.total,
);

export const selectEmployeeUploadStats = createSelector(
  selectEmployeeDomain,
  (domain) => domain?.employeeUploadStats,
);

export const selectChosenEmployees = createSelector(
  selectEmployeeDomain,
  (domain) => domain?.chosenEmployees || [],
);
